﻿'use strict';
var Backbone = require('backbone');
var PackageDeliveryPreference = require('../models/packageDeliveryPreference');

module.exports = Backbone.Collection.extend({
    model: PackageDeliveryPreference
});